import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var MasterApi = function () {
  function MasterApi(axios, store) {
    _classCallCheck(this, MasterApi);

    this.axios = axios;
  }

  _createClass(MasterApi, [{
    key: "findModelPosByProduct",
    value: function findModelPosByProduct(data) {
      return this.axios({
        url: "/master/master/model-pos",
        method: "POST",
        data: data
      });
    }
  }, {
    key: "findAllProductType",
    value: function findAllProductType() {
      return this.axios.$get("/master/master/find-All-Product-Type");
    }
  }, {
    key: "findAllProductByType",
    value: function findAllProductByType(data) {
      return this.axios.$post("/master/master/find-All-Product-By-Type", data);
    }
  }, {
    key: "newTariff",
    value: function newTariff(data) {
      return this.axios.$post("/tariff/tariff/", data);
    }
  }, {
    key: "getTariff",
    value: function getTariff() {
      return this.axios.$get("/tariff/tariff/");
    }
  }, {
    key: "tariff",
    value: function tariff(id) {
      return this.axios.$get("/tariff/tariff/" + id);
    }
  }, {
    key: "updateTariff",
    value: function updateTariff(data) {
      return this.axios.$patch("/tariff/tariff/" + data.idTariff, data);
    }
  }, {
    key: "findTariff",
    value: function findTariff(data) {
      return this.axios.$post("/tariff/tariff/hwa", data);
    }
  }, {
    key: "findAllDepartment",
    value: function findAllDepartment() {
      return this.axios.$get("/master/master/find-All-Departament");
    }
  }, {
    key: "findAllProvinceByDepartament",
    value: function findAllProvinceByDepartament(data) {
      return this.axios.$post("/master/master/find-All-Province-By-Departament", data);
    }
  }, {
    key: "findAllDistrictByProvince",
    value: function findAllDistrictByProvince(data) {
      return this.axios.$post("/master/master/find-All-District-By-Province", data);
    }
  }, {
    key: "findAllbank",
    value: function findAllbank() {
      return this.axios.$get("/master/master/find-All-bank");
    }
  }, {
    key: "findAllTypeAccountByBank",
    value: function findAllTypeAccountByBank(data) {
      return this.axios.$post("/master/master/find-All-Type-Account-By-Bank", data);
    }
  }, {
    key: "findAllTypeofRoad",
    value: function findAllTypeofRoad() {
      return this.axios.$get("/master/master/find-All-Type-of-Road");
    }
  }, {
    key: "findAllBusinessTurn",
    value: function findAllBusinessTurn() {
      return this.axios.$get("/master/master/find-All-Business-Turn");
    }
  }, {
    key: "findAllDocumentType",
    value: function findAllDocumentType() {
      return this.axios.$get("/master/master/find-All-Document-Type");
    }
  }, {
    key: "findAllCurrency",
    value: function findAllCurrency() {
      return this.axios.$get("/master/master/find-All-Currency");
    }
  }, {
    key: "findAllInteriorType",
    value: function findAllInteriorType() {
      return this.axios.$get("/master/master/find-All-Interior-Type");
    }
  }, {
    key: "findAllTypeDevelopment",
    value: function findAllTypeDevelopment() {
      return this.axios.$get("/master/master/find-All-Type-Development");
    }
  }, {
    key: "findAllPlatform",
    value: function findAllPlatform() {
      return this.axios.$get("/master/master/find-All-Platform");
    }
  }, {
    key: "findAllTypeOsv",
    value: function findAllTypeOsv() {
      return this.axios.$get("/master/master/find-All-type-osv");
    }
  }, {
    key: "findAllDocumentTypeUser",
    value: function findAllDocumentTypeUser() {
      return this.axios.$get("/master/master/find-All-Document-Type-User");
    }
  }, {
    key: "findAllUserCategories",
    value: function findAllUserCategories() {
      return this.axios.$get("/master/master/find-All-User-Category");
    }
  }, {
    key: "findAllEndpointsInit",
    value: function findAllEndpointsInit() {
      return this.axios.$get("/master/master/find-All-endpoints-initial");
    }
  }, {
    key: "findAllAllAgent",
    value: function findAllAllAgent() {
      return this.axios.$get("/master/master/find-All-Agent");
    }
  }, {
    key: "findAllAllAffiliationType",
    value: function findAllAllAffiliationType() {
      return this.axios.$get("/master/master/find-All-Affiliation-type");
    }
  }]);

  return MasterApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/master.js
// module id = ./src/api/master.js
// module chunks = 34